import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { SwitchRolePopupComponent } from '../comp/switch-role-popup/switch-role-popup.component';

@Injectable({
  providedIn: 'root'
})
export class SwitchRolePopupService {

  componentRef?: ComponentRef<SwitchRolePopupComponent>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector) {
    this.createPopup()
  }

  createPopup() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(SwitchRolePopupComponent);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    this.componentRef = componentRef;
  }

  showPopup(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.componentRef
        ?.instance
        .showPopup()
        .then(result => {
          resolve(result);
        })
        .catch(error => reject(error));
    });
  }
}
